import script from "./InvestView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestView.vue?vue&type=script&setup=true&lang=js"

import "./InvestView.vue?vue&type=style&index=0&id=573edf10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573edf10"]])

export default __exports__